.container {
  display: flex;
}

.shipments-by-age-graph {
  position: relative;
  margin-top: 20px;
}

.summary-bar {
  margin: 20px auto;
}

.chart-section {
  width: 50%;
  margin: 20px;
}
